import Flickity from './FlickityExended';

const AUTOPLAY_CLASS = 'slider--autoplay';
const INIT_CLASS = 'slider--init';

// Remove autoplay class on stop
Flickity.prototype.stopPlayer = function() {
    this.player.stop();
    this.element.classList.remove(AUTOPLAY_CLASS);
};

const STRINGS = document.body.dataset.slider.split(',');

// Set additional default values
const DEFAULTS = {
    pauseAutoPlayOnHover: false,
    pageDotAriaLabel: STRINGS[0],
    previousAriaLabel: STRINGS[1],
    nextAriaLabel: STRINGS[2],
    on: {
        ready: function() {
            if (this.options.autoPlay) {
                this.element.classList.add(AUTOPLAY_CLASS);
                setTimeout(() => {
                    this.element.classList.add(INIT_CLASS);
                }, 10);
            }
        }
    },
    arrowShape:
        'M24.816 48.001L71.987.83a2.831 2.831 0 014.005 4.003L30.83 49.995l45.162 45.163a2.84 2.84 0 01-1.99 4.842 2.76 2.76 0 01-1.99-.838L24.84 51.99a2.817 2.817 0 01-.024-3.989z'
};

Object.assign(Flickity.defaults, DEFAULTS);

// Add localized labels with this duck-punch code
// https://metafizzy.co/blog/duck-punching-prototype/

let addDots = Flickity.PageDots.prototype.addDots;
Flickity.PageDots.prototype.addDots = function() {
    addDots.apply(this, arguments);
    let ariaLabel = this.parent.options.pageDotAriaLabel;
    this.dots.forEach(function(dot, i) {
        let label = ariaLabel.replace('%n', i + 1);
        dot.setAttribute('aria-label', label);
    });
};

let _createButton = Flickity.PrevNextButton.prototype._create;
Flickity.PrevNextButton.prototype._create = function() {
    _createButton.apply(this, arguments);
    let optionName = this.isPrevious ? 'previous' : 'next';
    let label = this.parent.options[optionName + 'AriaLabel'];
    this.element.setAttribute('aria-label', label);
};

// add class if flickity resizes finised, used for make cell equal heights
Flickity.prototype._createResizeClass = function() {
    this.element.classList.add('flickity-resized');
};

Flickity.createMethods.push('_createResizeClass');

let resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
    this.element.classList.remove('flickity-resized');
    resize.call(this);
    this.element.classList.add('flickity-resized');
};

export default Flickity;
